import React, { } from "react";
import _ from 'lodash';
import { IconButton, Tooltip } from "@mui/material";
import { InfoOutlined } from "@mui/icons-material";

import "../styles/Select.css"

type Props = {
  label?: string,
  description: string,
}

const AsyncMultiInfoLabel = ({ label, description }: Props) => {

  return (
    <div className="description">
      {label}
      {!!description && (
        <Tooltip
          title={description}
          arrow={true}
        >
          <IconButton size="small">
            <InfoOutlined />
          </IconButton>
        </Tooltip>
      )}
    </div>
  )
}

export default AsyncMultiInfoLabel;
